/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */
import { Icon, Grid, Loader, FileDrop, Card, Table, InputLabel } from '@scuf/common';
import * as React from 'react';
import { util } from '@keystone/common';
import { VadContext } from './VadContext';

class VadScan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: null,
      loadingSettings: false,
      text: 'Scanning ...',
    };
  }

  componentDidMount() {
    const { home } = this.context;
    home();
  }

  componentWillUnmount() {
    const { resetResults } = this.context;
    resetResults(null);
  }

  onAccepted = async (fileList) => {
    const { scanVad } = this.context;
    this.toggleLoading();
    const data = new FormData();
    // get first (only) file from list
    data.append('data', fileList[0]);
    this.setState({
      fileName: fileList[0].name,
    });
    await scanVad(data);
    this.toggleLoading();
  };

  // eslint-disable-next-line class-methods-use-this
  getCellItem(scanResult) {
    return (
      <Table.Row>
        <Table.Cell width="2">{scanResult.lineNumber}</Table.Cell>
        <Table.Cell width="6">{scanResult.matchingString}</Table.Cell>
        <Table.Cell width="8">{scanResult.displayMessage}</Table.Cell>
      </Table.Row>
    );
  }

  getProducts(scanResultArray, key) {
    return (
      <Grid.Row>
        <Grid.Column width={12}>
          <Card>
            <Card.Header>File({key})</Card.Header>
            <Card.Content>
              <Table>
                <Table.Header>
                  <Table.HeaderCell content="Line #" />
                  <Table.HeaderCell content="Code Block" />
                  <Table.HeaderCell content="Resolution" />
                </Table.Header>
                <Table.Body>
                  {scanResultArray.map((scanResult) => this.getCellItem(scanResult))}
                </Table.Body>
              </Table>
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid.Row>
    );
  }

  toggleLoading() {
    this.setState((prevState) => ({
      loadingSettings: !prevState.loadingSettings,
    }));
  }

  fileReset() {
    const { resetResults, home } = this.context;
    resetResults(null);
    home();
  }

  // eslint-disable-next-line class-methods-use-this
  displayResults(scanResultArray) {
    return (
      <Grid.Row>
        <Grid.Column width={12}>
          <Card>
            <Card.Header>Rule</Card.Header>
            <Card.Content>
              <Table>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      {scanResultArray.searchRule.regularExpression ? (
                        <InputLabel label="Unsupported Regex" width="2" />
                      ) : (
                        <InputLabel label="Unsupported Code" width="2" />
                      )}
                    </Table.Cell>
                    <Table.Cell width="12">{scanResultArray.searchRule.matchingString}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <InputLabel label="Description" width="2" />
                    </Table.Cell>
                    <Table.Cell width="12">{scanResultArray.searchRule.description}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <InputLabel label="Resolution" width="2" />
                    </Table.Cell>
                    <Table.Cell width="12">{scanResultArray.searchRule.displayMessage}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan="2">
                      <Card>
                        <Card.Header>Affected Files</Card.Header>
                        <Card.Content>
                          <Table>
                            <Table.Header>
                              <Table.HeaderCell content="File" />
                              <Table.HeaderCell content="Line #" />
                            </Table.Header>
                            <Table.Body>
                              {Object.keys(scanResultArray.fileDetails).map((key) =>
                                scanResultArray.fileDetails[key] ? (
                                  <Table.Row>
                                    <Table.Cell width="8">{key}</Table.Cell>
                                    <Table.Cell width="4">
                                      {scanResultArray.fileDetails[key]}
                                    </Table.Cell>
                                  </Table.Row>
                                ) : null
                              )}
                            </Table.Body>
                          </Table>
                        </Card.Content>
                      </Card>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const { loadingSettings, text, fileName } = this.state;
    const { results, getIdToken, pdfFileName } = this.context;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <Loader
              loading={loadingSettings}
              overlayOpacity={0.2}
              overlayColor="#B2AFAF"
              text={text}
            >
              <div className="placeholder" />
            </Loader>
            <Card>
              <FileDrop
                acceptedTypes={['.vad', '.zip']}
                placeholder="Drop or Upload VoiceArtisan Application(.vad or .zip)"
                onAccepted={(fileList) => this.onAccepted(fileList)}
                onReset={() => this.fileReset()}
                multiple={false}
              />
            </Card>
          </Grid.Column>
        </Grid.Row>
        {results != null ? (
          <>
            <Grid.Row>
              <Grid.Column width={11}>
                <h2>Scan results of file ({fileName})</h2>
              </Grid.Column>
              <Grid.Column width={1}>
                <a
                  onClick={() => null}
                  href={`${util.getAPIGatewayURL()}/vactool/artisan/vad/download?id_token=${getIdToken()}&pdfFileName=${pdfFileName}`}
                >
                  <Icon name="file-download" size="large" className="right" />
                </a>
              </Grid.Column>
            </Grid.Row>
          </>
        ) : null}

        {results != null
          ? Object.keys(results).map((key) =>
              results[key] ? this.displayResults(results[key]) : null
            )
          : null}
      </Grid>
    );
  }
}

VadScan.contextType = VadContext;

export default VadScan;
